const markRequired = (arr: string[]) => {
  return arr.map(x => {
    return {
      source: x,
      validation: {
        required: true
      }
    };
  })
}

const markReadonlyTrue = (arr: string[]) => {
  return arr.map(x => {
    return {
      source: x,
      readonly: true
    }
  })
}

const markReadonlyFalse = (arr: string[]) => {
  return arr.map(x => {
    return {
      source: x,
      readonly: false
    }
  })
}

export const modifiers = {
  markRequired,
  markReadonlyTrue,
  markReadonlyFalse
}
